import { render, staticRenderFns } from "./RemoveTeamMember.vue?vue&type=template&id=37672326&scoped=true"
import script from "./RemoveTeamMember.vue?vue&type=script&lang=js"
export * from "./RemoveTeamMember.vue?vue&type=script&lang=js"
import style0 from "./RemoveTeamMember.vue?vue&type=style&index=0&id=37672326&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37672326",
  null
  
)

export default component.exports